import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import DynamicForm from '../components/DynamicForm';
import { devicePolicyFormFields } from './DevicePolicyFieldsConfig';
import { toast } from 'react-toastify';
import { createDevicePolicy } from '../commonApi';
import 'bootstrap-icons/font/bootstrap-icons.css';

export const AddDevicePolicy = ({ show, onClose, onSuccess }) => {
  const [showJsonExample, setShowJsonExample] = useState(false);
  const jsonPopupRef = useRef();

  const exampleJson = JSON.stringify(
    {
      Version: "2012-10-17",
      Statement: [
        {
          Effect: "Allow",
          Action: "iot:Connect",
          Resource: [
            "arn:aws:iot:<region>:<account_id>:client/${iot:Connection.Thing.ThingName}"
          ]
        },
        {
          Effect: "Allow",
          Action: "iot:Publish",
          Resource: [
            "arn:aws:iot:<region>:<account_id>:topic/device/${iot:Connection.Thing.ThingName}/data"
          ]
        },
        {
          Effect: "Allow",
          Action: "iot:Subscribe",
          Resource: [
            "arn:aws:iot:<region>:<account_id>:topicfilter/device/${iot:Connection.Thing.ThingName}/data"
          ]
        },
        {
          Effect: "Allow",
          Action: "iot:Receive",
          Resource: [
            "arn:aws:iot:<region>:<account_id>:topic/device/${iot:Connection.Thing.ThingName}/data"
          ]
        }
      ]
    },
    null,
    2
  );
  

  const handleCopyJson = () => {
    navigator.clipboard.writeText(exampleJson);
    toast.success("Example JSON copied to clipboard!");
    setShowJsonExample(false); 
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        jsonPopupRef.current &&
        !jsonPopupRef.current.contains(event.target)
      ) {
        setShowJsonExample(false);
      }
    };

    if (showJsonExample) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showJsonExample]);

  const handleSubmit = async (formData) => {
    try {
      await createDevicePolicy({
        name: formData.name,
        description: formData.description??'',
        policyJson: formData.policyJson,
      });
      toast.success("Device policy created successfully!");
      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      const errorMessage =
        error.response?.data?.error?.message || "Failed to create device policy!";
      toast.error(errorMessage);
      console.error("Error creating policy:", error);
    }
  };

  const updatedFormFields = devicePolicyFormFields.map((field) =>
    field.name === "policyJson"
      ? {
          ...field,
          renderAddon: () => (
            <>
              <i
                className="bi bi-info-circle-fill text-primary"
                style={{ cursor: "pointer", marginLeft: "8px"}}
                onClick={() => setShowJsonExample(true)}
                title="View example JSON"
              ></i>
          
              {showJsonExample && (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{ backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1055 }}
                >
                  <div
                    ref={jsonPopupRef}
                    className="bg-white p-4 rounded shadow"
                    style={{ maxWidth: "600px", width: "90%" }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <strong>Example JSON</strong>
                      <button
                        className="btn-close"
                        onClick={() => setShowJsonExample(false)}
                      ></button>
                    </div>
                    <pre
                      style={{
                        background: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "6px",
                        fontSize: "0.9rem",
                        maxHeight: "300px",
                        overflowY: "auto",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {exampleJson}
                    </pre>
                    <div className="text-end mt-2">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={handleCopyJson}
                      >
                        Copy & Use
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          ),          
        }
      : field
  );

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Device Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DynamicForm
        formClass={"policy-form"}
          fields={updatedFormFields}
          onSubmit={handleSubmit}
          onError={(err) => {
            console.log("Validation Errors:", err);
            toast.error("Please fix the form errors before submitting.");
          }}
          onClose={onClose}
          submitButtonText="Create Policy"
        />
      </Modal.Body>
    </Modal>
  );
};
